export default "__VITE_ASSET__Dw6pT7$f__"